import React from "react";
import { Link } from "gatsby";
import Layout from "../../components/motorrad/layout";
import SEO from "../../components/motorrad/seo";
import FlexCard from "../../components/motorrad/flexcard";
import DrivingSchoolCard from "../../components/drivingschoolcard";
import HomeVideoBackground from "../../components/homevideobackground";
import settings from "../../../settings";

const bmwonroad = `${settings.IMAGES_BASE_URL}/images/motorrad/home/bmw-on-road-motorcycle-course.jpg`;
const bmwoffroad = `${settings.IMAGES_BASE_URL}/images/motorrad/home/bmw-off-road-motorcycle-course.jpg`;
const poster = `${settings.IMAGES_BASE_URL}/images/motorrad/home/poster-image-moto.jpg`;
const creditCard = `${settings.IMAGES_BASE_URL}/images/motorrad/home/moto-cc-home.jpg`;
const dirtyCardBanner = `${settings.IMAGES_BASE_URL}/images/motorrad/home/off-road-booking.jpg`;
const girlPowerBanner = `${settings.IMAGES_BASE_URL}/images/motorrad/home/girl-power.jpg`;
const twoWayBanner = `${settings.IMAGES_BASE_URL}/images/motorrad/home/dirt-street-moto.jpg`;
const holidayBanner = `${settings.IMAGES_BASE_URL}/images/motorrad/home/moto-holiday-v2.jpg`;
const toursBanner = `${settings.IMAGES_BASE_URL}/images/motorrad/home/moto-tours.jpg`;
const fathersDayBanner = `${settings.IMAGES_BASE_URL}/images/motorrad/home/fathers-day.jpg`;


const videoUrl = `${settings.IMAGES_BASE_URL}/videos/moto.mp4`;
const today = new Date();
const showGirlPowerCard =
  today >= new Date(2025,8,5) &&
  today < new Date(2025,8,30);
const showDirtyCard =
  today >= new Date(2025,8,30);
const showFathersDayCard =
  today >= new Date(2026,4,15) &&
  today < new Date(2026,6,1);

const getRowType =(rowNum) => {
  if (rowNum % 2 === 0) {
    return "row-reverse";
  } else {
    return "row";
  }
};

class IndexPage extends React.Component {
  constructor(props) {
    super(props);
    this.rowNum = 0;
  }

  getFathersDayCard = () => {
    return (
      <FlexCard
          rowType={getRowType(++this.rowNum)}
          image={fathersDayBanner}
          imageAlt="THIS FATHER’S DAY, NOTHING SAYS THANKS LIKE EXCITEMENT ON TWO WHEELS."
          header="THIS FATHER’S DAY, NOTHING SAYS THANKS LIKE EXCITEMENT ON TWO WHEELS."
          subheader="20% OFF A GIFT CARD"
      >
        <p>
          Get 20% off a gift card for select riding classes and Experiences at BMW U.S. Rider Academy through June 30th, 2026, at our Spartanburg, South Carolina location. Call 888-345-4269 to book your class using code <strong>26RFDGC20</strong>. May not be combined with any other offers and excludes Motorcycle Safety Foundation Course, Private Instruction or Moto Tours.
        </p>
        <Link to="/motorrad/schools">
          <button className="btn btn-bordered">LEARN MORE</button>
        </Link>
      </FlexCard>
    )
  }
  getGirlPowerCard= () => {
    return (
      <FlexCard
          rowType={getRowType(++this.rowNum)}
          image={girlPowerBanner}
          imageAlt="GIRL POWER"
          header="GIRL POWER"
          subheader="THREE-DAY WOMEN’S ADVENTURE RIDING NOW OPEN"
      >
        <p>
          Grab some friends and make it a long (and fun) weekend on November 1, 2025. We’ve just opened a Three-Day Women’s Adventure Riding course, and it’s filling fast. </p>       
          <Link to="/motorrad/schools">
          <button className="btn btn-bordered">LEARN MORE</button>
        </Link>
      </FlexCard>
    )
  }
  getHolidayCard = () => {
    return (
      <FlexCard
          rowType={getRowType(++this.rowNum)}
          image={holidayBanner}
          imageAlt="SLIDE A GIFT CARD INTO THEIR STOCKING"
          header="SLIDE A GIFT CARD INTO THEIR STOCKING"
          subheader="GET 20% OFF SELECT CLASSES"
      >
        <p>
          Gift a class to family and friends at the BMW U.S. Rider Academy. Right now you can get 20% off select classes, and it's the best way to make your favorite rider smile this holiday season. Please call 888-345-4269 to order and use code 25RIDHPH20. Excludes private instruction, Motorcycle Foundation Course and Tours. Offer valid through 12/31/25.
        </p>
        <Link to="tel:888-345-4269">
          <button className="btn btn-bordered">CALL 888-345-4269 TO BOOK YOUR CLASS</button>
        </Link>
      </FlexCard>
    )
  }

  getToursCard = () => {
    return (
      <FlexCard
          rowType={getRowType(++this.rowNum)}
          image={toursBanner}
          imageAlt="2026 INTERNATIONAL TOURS NOW OPEN"
          header="2026 INTERNATIONAL TOURS NOW OPEN"
          subheader="SEE SPAIN AND SICILY"
      >
        <p>
          Tours of Spain and Sicily are now open, and seats are filling up quickly. Book yours today and experience the trip of a lifetime.
        </p>
        <Link to="/motorrad/touring">
          <button className="btn btn-bordered">LEARN MORE</button>
        </Link>
      </FlexCard>
    )
  }

  getDirtyCard = () => {
    return (
      <FlexCard
          rowType={getRowType(++this.rowNum)}
          image={dirtyCardBanner}
          imageAlt="TIME TO GET DIRTY"
          header="TIME TO GET DIRTY"
          subheader="OFF-ROAD CLASSES BOOKING NOW"
      >
        <p>
          Our Off-road Classes combine skills and thrills over the course of one, two or three full days. Classes are filling up quickly, so grab a set of handlebars and book your seat.
        </p>
        <Link to="/motorrad/schools">
          <button className="btn btn-bordered">LEARN MORE</button>
        </Link>
      </FlexCard>
    )
  }

  getDefaultCard = () => {
    // Holiday banner shows until 11:59PM 12/31/25, then International Tours banner
    const holidayEndDate = new Date(2026, 0, 1); // January 1, 2026

    if (showFathersDayCard) {
      return (
        <>
          {this.getFathersDayCard()};
          {this.getToursCard()};
        </>
      )
    } else if (showGirlPowerCard){
      return (
        <>
          {this.getGirlPowerCard()};
          {this.getTwoWayCard()};
        </>
      )
    } else if (today < holidayEndDate) {
      return (
        <>
          {this.getHolidayCard()};
        </>
      )
    } else {
      return (
        <>
          {this.getToursCard()};
        </>
      )
    }
  };

  getGoProCard =  () => {
    return (
      <FlexCard
          rowType={getRowType(++this.rowNum)}
          image={creditCard}
          imageAlt="BMW Mottorrad Reward"
          header="Rewards At Full Throttle"
          subheader="SAVE ON CLASSES WITH THE BMW MOTORRAD CARD"
      >
        <p>
          Accelerate your rewards with the BMW Motorrad Card – exclusively for BMW Motorrad riders. Redeem for unlimited cash back toward your BMW Motorrad Financial Services monthly payment or travel. Plus, you’ll save when you book a class with us over the phone.
        </p>
        <Link to="https://www.mybmwmotorradcard.com/41627" target="_blank" >
          <button className="btn btn-bordered">LEARN MORE ABOUT THE BMW MOTORRAD CARD</button>
        </Link>
      </FlexCard>
    )
  };

  getTwoWayCard = () => {
    return (
      <FlexCard
        rowType={getRowType(++this.rowNum)}
        image={twoWayBanner}
        imageAlt="TWO-WAY STREET"
        header="TWO-WAY STREET"
        subheader="BOOK A WEEKEND OF ON- AND OFF-ROAD THRILLS"
      >
        <p>
          Get a taste of adventure with a combination weekend of on- and off-road courses. One day focuses on street riding, and the other on off-road skillsets. Available weekends include 8/23 - 8/24, 11/15 - 11/16 and 12/6 - 12/7.
        </p>
        <Link to="/motorrad/schools">
          <button className="btn btn-bordered">LEARN MORE</button>
        </Link>
      </FlexCard>
    )
  }

  render() {
    return (
      <Layout>
        <SEO
          title="The BMW U.S. Rider Academy | Motorrad Tours and Classes"
          description="The BMW U.S. Rider Academy offers custom motorrad tours, riding classes – on and off-road, of course, and the chance to ride and try the latest BMW motorcycles."
        />
        <HomeVideoBackground
          headerTitle="Wheels Down, Throttle out, let’s ride"
          url={videoUrl}
          poster={poster}
          motorradvolume="true"
        />
        <section className="performance-center">
          <div className="container">
            <div className="performance-center__header">
              <h1 className="motorrad__title">THE BMW U.S. RIDER ACADEMY</h1>
            </div>
          </div>
          {this.getDefaultCard()}
          {this.getGoProCard()}
        </section>

        <section className="testimonial">
          <div className="testimonial__content">
            <h3>
              “I’ve ridden for years and was amazed at the amount of info I
              didn’t have.”
            </h3>
            <span> - Jeff H.</span>
          </div>
        </section>

        <section className="drivingschool">
          <div className="container">
            <div className="drivingschool__header">
              <h2>BMW RIDING SCHOOLS</h2>
            </div>
          </div>
          <DrivingSchoolCard
            rowType="row"
            image={bmwonroad}
            imageAlt="image of Fast Car"
            header="ON-ROAD"
            subheaderMini="LET THE MOMENTUM GRAB YOU"
            text="Build a momentum of technique, control and comfort in the saddle with every new revolution of the wheel. We’ll cover controlled clutch and throttle movements, low-speed maneuverability, overall balance and more. Every scenario is built to enhance your real-world enjoyment and safety when riding. Rev it up."
            learnUrl="/motorrad/schools?utm_source=MotorradHomePage&utm_medium=banner4&utm_campaign=OnRoadGrab"
            learnBtnStyle="btn-black"
            bookBtnStyle="btn-bordered"
            callBtn="true"
          />
          <DrivingSchoolCard
            rowType="row"
            image={bmwoffroad}
            imageAlt="image of Driver School Car"
            header="OFF-ROAD"
            subheaderMini="OPEN THE DOOR TO NEW ADVENTURES"
            text="Only five percent of the world’s roads are paved, which means one thing: You’re going to get dirty. Off-road classes traverse challenging terrain that leaves students with increased confidence and newfound riding ability."
            learnUrl="/motorrad/schools?utm_source=MotorradHomePage&utm_medium=banner5&utm_campaign=OffRoadDoor"
            learnBtnStyle="btn-black"
            bookBtnStyle="btn-bordered"
            callBtn="true"
          />
        </section>
      </Layout>
    );
  }
}
export default IndexPage;
